import InsertUploadedPagePanel from './InsertUploadedPagePanelContainer';

export default InsertUploadedPagePanel;